export default __webpack_public_path__ + "static/media/news2.3954e856.jpeg";